function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import moment from 'moment';
import allowedTimeRangeMixins from './allowedTimeRangeMixins';
export default {
  name: 'CoreDateTimePickerField',
  mixins: [allowedTimeRangeMixins],
  props: {
    label: {
      type: String,
      required: true,
      "default": ''
    },
    value: {
      type: String,
      required: true
    },
    dateValue: {
      type: Number,
      required: true
    },
    rules: {
      type: Array,
      required: true
    },
    firstDayOfWeek: {
      type: String,
      required: false,
      "default": '1'
    }
  },
  data: function data() {
    return {
      pickerDate: null,
      showPickerDialog: false
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])),
  watch: {
    dateValue: function dateValue() {
      this.setupPickerDate();
    }
  },
  created: function created() {
    this.setupPickerDate();
  },
  methods: {
    setupPickerDate: function setupPickerDate() {
      if (new Date(this.dateValue).toString() !== 'Invalid Date') {
        this.pickerDate = moment(new Date(this.dateValue * 1000)).format('YYYY-MM-DD');
      } else {
        this.pickerDate = moment(new Date()).format('YYYY-MM-DD');
      }
    },
    handleDateSelected: function handleDateSelected(isoDateString) {
      this.$emit('date:picked', isoDateString);
    },
    handleDateChanged: function handleDateChanged(value) {
      this.$emit('date:changed', value);
    }
  }
};